import {
    GET_DAY_PLANNER_DATA,
    GET_DAY_PLANNER_DATA_SUCCESS,
    GET_DAY_PLANNER_DATA_FAILURE,
    TOGGLE_DAY_CONFIG_SIDE_PANEL,
    SAVE_DAY_PLANNER_CONFIG,
    SAVE_DAY_PLANNER_CONFIG_SUCCESS,
    SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR,
    SAVE_DAY_PLANNER_CONFIG_FAILURE,
    TOGGLE_ADD_DIVISIONS_SIDE_PANEL,
    UPDATE_DAY_PLAN,
    SET_SELECTED_SCHEDULED_VIRTUAL_DRAW,
    SET_PREVIOUS_DAY,
    TOGGLE_SUMMARY_SIDE_PANEL,
} from '../actions/actionTypes/day-planner-types';

const initialState = {
    isLoadingPlannerData: false,
    isSavingDayConfig: false,
    showDayConfigModal: false,
    showConfirmClearSchedule: false,
    showAddDivisionsSidePanel: false,
    showSummarySidePanel: false,
    eventPlan: null,
    dayPlan: null,
    dayConfig: null,
    viewState: {
        day: null,
        facilityId: null,
    },
    enabledFacilitiesForDay: [],
    scheduledVirtualDraws: [],
    selectedScheduledVirtualDraw: '',
    previousDay: null,
};

function dayPlannerReducer(state = initialState, action) {
    switch (action.type) {
        case GET_DAY_PLANNER_DATA:
            return {
                ...state,
                isLoadingPlannerData: true,
                eventPlan: null,
                dayPlan: null,
                dayConfig: null,
                viewState: {
                    day: action.payload.day,
                    facilityId: action.payload.facilityId,
                },
                enabledFacilitiesForDay: [],
                scheduledDraws: [],
                selectedScheduledVirtualDraw: '',
            };
        case GET_DAY_PLANNER_DATA_SUCCESS:
            return {
                ...state,
                isLoadingPlannerData: false,
                eventPlan: action.payload.eventPlan,
                dayConfig: action.payload.dayConfig,
                viewState: action.payload.viewState,
                enabledFacilitiesForDay: action.payload.enabledFacilitiesForDay,
                showDayConfigModal: action.payload.showDayConfigModal,
            };
        case GET_DAY_PLANNER_DATA_FAILURE:
            return {
                ...state,
                isLoadingPlannerData: false,
                showDayConfigModal: action.payload.showDayConfigModal,
                viewState: action.payload?.viewState || initialState.viewState,
                enabledFacilitiesForDay: [],
                scheduledDraws: [],
                selectedScheduledVirtualDraw: '',
            };
        case TOGGLE_DAY_CONFIG_SIDE_PANEL:
            return {
                ...state,
                showDayConfigModal: action.payload.showDayConfigModal,
            };
        case TOGGLE_ADD_DIVISIONS_SIDE_PANEL:
            return {
                ...state,
                showAddDivisionsSidePanel: action.payload.showAddDivisionsSidePanel,
            };
        case TOGGLE_SUMMARY_SIDE_PANEL:
            return {
                ...state,
                showSummarySidePanel: action.payload.showSummarySidePanel,
            };
        case SAVE_DAY_PLANNER_CONFIG:
            return {
                ...state,
                isSavingDayConfig: true,
                showConfirmClearSchedule: false,
            };
        case SAVE_DAY_PLANNER_CONFIG_SUCCESS:
            return {
                ...state,
                showDayConfigModal: action.payload.showDayConfigModal,
                isSavingDayConfig: false,
                showConfirmClearSchedule: false,
            };
        case SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR:
            return {
                ...state,
                isSavingDayConfig: false,
                showConfirmClearSchedule: action.payload.showConfirmClearSchedule,
            };
        case SAVE_DAY_PLANNER_CONFIG_FAILURE:
            return {
                ...state,
                isSavingDayConfig: false,
                showConfirmClearSchedule: false,
            };
        case UPDATE_DAY_PLAN:
            return {
                ...state,
                dayPlan: action.payload.dayPlan,
                scheduledVirtualDraws: action.payload.scheduledVirtualDraws,
                selectedScheduledVirtualDraw: '',
            };
        case SET_SELECTED_SCHEDULED_VIRTUAL_DRAW:
            return {
                ...state,
                selectedScheduledVirtualDraw: action.payload.selectedScheduledVirtualDraw,
            };
        case SET_PREVIOUS_DAY:
            return {
                ...state,
                previousDay: action.payload.previousDay,
            };
        default:
            return state;
    }
}

export default dayPlannerReducer;
